import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5g5bvol3h2: FaireBrandEntity = {
  token: "b_5g5bvol3h2",
  type: "brand",
  name: "Dan&Darci",
  avatarUrl:
    "https://cdn.faire.com/fastly/173ea65d86523f08b49a6e7b7f13ac6ce91dbf57e9c5b8f6c126b48ae85a11c0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c990c10695015ee06282decd8a46ef6c075ff10dbdbb12119a4aa7a0ee750df1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/173ea65d86523f08b49a6e7b7f13ac6ce91dbf57e9c5b8f6c126b48ae85a11c0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c990c10695015ee06282decd8a46ef6c075ff10dbdbb12119a4aa7a0ee750df1.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 30,
  rating: 4.8,
  reviewCount: 378,
  isInsider: true,
  description:
    "Dan&Darci is a premier toy brand dedicated to helping children learn and grow. Today’s children are spending ever-increasing amounts of time glued to screens and other unproductive pastimes. Parents are thrilled to find toys for their children that are both educational and exciting, which is what differentiates our products from the rest. Our innovative line of  STEM science kits and toys fascinates and engages kids while educating them at the same time. The market for STEM toys is one of the fastest-growing, fostered by an increased parental desire to take a more active hand in their child’s educational development.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:32.282Z",
    importedBy: "entity-db-cli",
  },
};
